import { Configuration } from '../app.constants'
import { Injectable } from '@angular/core'
import { Profile } from '../models/profile.model';
import { HttpClient, HttpHeaders } from '@angular/common/http'

@Injectable()
export class HelperService {

  constructor(private http: HttpClient) {
  }

  getDaysTrialLeft(profile: Profile) {
    if (profile.trialActive && profile.trialEndDate != null) {
      var eventStartTime = new Date();
      var eventEndTime = new Date(profile.trialEndDate);
      var diff = eventEndTime.valueOf() - eventStartTime.valueOf();
      return Math.ceil(diff / (1000 * 3600 * 24));
    }
  }

  getScript(profile: Profile): any {

    var staticUrl = Configuration.staticUrl

    var script = `<div id="polenScript" class="polen-` + profile.apiKey + `">
        <script>
          (function () {
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.async = true;
            script.src = "` + staticUrl + (profile.platformInfo ? profile.platformInfo.platformJavascript : profile.integrationType == 0 ? `polen-generic-bloomer` : `polen-generic-pollinator`) + `.min.js";
            var s = document.getElementsByTagName("script")[0];
            s.parentNode.insertBefore(script, s);
          })();
        </script>
      </div>`
    return script
  }

  // getSeloCompreDoeScript(profile: Profile): any {
  //   var script =
  //     `<div id="selo-compredoe">
  //     <a href="https://polen.com.br/impacto/` + profile.storeSeoName + `?utm_source=` + profile.storeSeoName + `&utm_medium=selo_compredoe"  target="_blank">
  //         <img src="https://verificado.compreedoe.com.br/selo/` + profile.apiKey + `" width="150px" style="max-width:150px;max-height: 68px;" />	
  //       </a>        
  //   </div>`
  //   return script
  // }

  getSeloCompreDoeScript(profile: Profile): any {
    var script =
      `<div id="selo-movimento-quemtransforma">
      <a href="https://polen.com.br/impacto/` + profile.storeSeoName + `?utm_source=` + profile.storeSeoName + `&utm_medium=selo_quemtransforma"  target="_blank">
          <img src="https://verificado.compreedoe.com.br/selo/` + profile.apiKey + `" width="100px" style="max-width:200px;max-height: 200px;height:100px" />	
        </a>        
    </div>`
    return script
  }

  sendEmail(profile: Profile): any {

  }

  sendEmailScriptToDeveloper(email, name, seoUrl): any {
    return this.http.get(Configuration.apiUrl + 'Api/Profile/SendEmailScriptToDeveloper?email=' + email + '&name=' + name + '&seoUrl=' + seoUrl)
  }

  isNullOrEmpty(text) {
    return (text == null || text == '')
  }

  replaceAll(str, find, replace) {
    if (str == null)
      return str
    return str.replace(new RegExp(this.escapeRegExp(find), 'g'), replace);
  }

  replaceSpaceAndAccents(str) {
   return str.replace(/[^A-Z0-9]+/ig, "");
  }

  escapeRegExp(str) {
    if (str == null)
      return str
    return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
  }

  //pega os ultimos lastCount do text
  getLastCharacters(text, lastCount) {
    if (!this.isNullOrEmpty(text))
      return text.trim().slice(text.length - lastCount)
    return text;
  }

  public findInvalidControls(f) {
    try {
      const invalid = [];
      const controls = f.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          invalid.push(name);
        }
      }
      console.log(invalid);
      return invalid;
    } catch (error) {
      return null;
    }

  }
}